import React from 'react'

const Footer = () => {
  return (
    <footer className='py-5 px-2.5 absolute bottom-0 w-full'>
        <p className='nex-text is-success text-center'>Made with 💟</p>
        <div className="social flex flex-wrap gap-1 justify-around items-center">
            <a href="https://twitter.com/US_Khokhar" target='_blank'> 
                <i className="social-icons nes-icon twitter is-small"></i>
            </a>
            <a href="https://www.instagram.com/u.s.khokhar/" target='_blank'> 
                <i className="social-icons nes-icon instagram is-small"></i>
            </a>
            <a href="https://github.com/USKhokhar" target='_blank'> 
                <i className="social-icons nes-icon github is-small"></i>
            </a>
            <a href="https://www.reddit.com/user/USKhokhar" target='_blank'> 
                <i className="social-icons nes-icon reddit is-small"></i>
            </a>
        </div>
    </footer>
  )
}

export default Footer